/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum ContentRole {
  DEFAULT = "DEFAULT",
  EDITOR = "EDITOR",
  VIEWER = "VIEWER",
}

export enum PrincipalType {
  GROUP = "GROUP",
  USER = "USER",
}

export interface UpdateContentPermissionsInput {
  contentRole: ContentRole;
  principalId: string;
  principalType: PrincipalType;
}

//==============================================================
// END Enums and Input Objects
//==============================================================

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateContentPermissionsMutation
// ====================================================

export interface UpdateContentPermissionsMutation_updateContentPermissions {
  status: boolean;
}

export interface UpdateContentPermissionsMutation {
  updateContentPermissions: UpdateContentPermissionsMutation_updateContentPermissions;
}

export interface UpdateContentPermissionsMutationVariables {
  contentId: string;
  input: (UpdateContentPermissionsInput | null)[];
}
